import React, { Component } from 'react';
import {
    Modal, Form, Input, InputNumber, Radio, Button,
} from 'antd';

import AddressAutoComplete from './AddressAutocomplete';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class UnwrappedAddressModalForm extends Component {
    componentDidMount = () => {
    };

    fillInAddress = () => {
        const { form } = this.props;
        const { setFieldsValue, getFieldValue } = form;

        const componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            sublocality_level_2: 'long_name',
            sublocality_level_1: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'long_name',
            country: 'long_name',
            postal_code: 'short_name',
        };
        // Get the place details from the autocomplete object.
        const place = window.autocomplete.getPlace();

        setFieldsValue({ line_1: '' });
        setFieldsValue({ line_2: '' });
        setFieldsValue({ city: '' });
        setFieldsValue({ state: '' });
        setFieldsValue({ pin_code: '' });
        setFieldsValue({ country: '' });

        for (let i = 0; i < place.address_components.length; i++) {
            const addressType = place.address_components[i].types[0];
            if (addressType === 'street_number') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ line_1: val });
            } else if (addressType === 'route') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ line_2: `${val}, ` });
            } else if (addressType === 'sublocality_level_2') {
                const val = place.address_components[i][componentForm[addressType]];
                const val1 = getFieldValue('line_2');
                setFieldsValue({ line_2: `${val1 + val}, ` });
            } else if (addressType === 'sublocality_level_1') {
                const val = place.address_components[i][componentForm[addressType]];
                const val1 = getFieldValue('line_2');
                setFieldsValue({ line_2: `${val1 + val}` });
            } else if (addressType === 'locality') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ city: val });
            } else if (addressType === 'administrative_area_level_1') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ state: val });
            } else if (addressType === 'postal_code') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ pin_code: val });
            } else if (addressType === 'country') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ country: val });
            }
        }
    }

    render() {
        const {
            data, form, visible, onCancel, onCreate, confirmLoading,
        } = this.props;

        const {
            line_1, line_2, city, pin_code, state, country, address_name,
        } = data;

        const editing = Object.keys(data).length !== 0;

        const { getFieldDecorator } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };

        return (
            <div>
                <Modal
                    visible={visible}
                    title={Object.keys(data).length === 0 ? 'Add New Address' : 'Edit Address'}
                    style={{ textAlign: 'center', fontSize: '1.2em', top: 20 }}
                    onCancel={onCancel}
                    footer={[
                        <Button key="cancel" onClick={onCancel}>Return</Button>,
                        <Button key="submit" type="primary" loading={confirmLoading} onClick={onCreate}>
                            Submit
                        </Button>,
                    ]}
                >

                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="Address Type"
                        >
                            {getFieldDecorator('address_name', {
                                rules: [{ required: true, message: 'Please select type of address' }],
                                initialValue: editing ? address_name == null ? 'Home' : address_name : 'Home',
                            })(
                                <RadioGroup>
                                    <RadioButton value="Home">Home</RadioButton>
                                    <RadioButton value="Work">Work</RadioButton>
                                    <RadioButton value="Other">Other</RadioButton>
                                </RadioGroup>,
                            )}
                        </FormItem>

                        {/* –––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––– */}

                        <h5 style={{ textAlign: 'center' }}>––––––––––––– Address –––––––––––––</h5>

                        <AddressAutoComplete
                            fillInAddress={this.fillInAddress}
                        />

                        <FormItem
                            {...formItemLayout}
                            label="Street address"
                        >
                            {getFieldDecorator('line_1', {
                                rules: [{ required: false, message: 'Line 1' }],
                                initialValue: editing ? line_1 == null ? '' : line_1 : '',
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Sublocality"
                        >
                            {getFieldDecorator('line_2', {
                                rules: [{ required: false, message: 'Line 1' }],
                                initialValue: editing ? line_2 == null ? '' : line_2 : '',
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="City"
                        >
                            {getFieldDecorator('city', {
                                rules: [{ required: false, message: 'Line 1' }],
                                initialValue: editing ? city == null ? '' : city : '',
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="State"
                        >
                            {getFieldDecorator('state', {
                                rules: [{ required: false, message: 'Line 1' }],
                                initialValue: editing ? state == null ? '' : state : '',
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Pin Code"
                        >
                            {getFieldDecorator('pin_code', {
                                rules: [{ required: false, message: 'Line 1' }],
                                initialValue: editing ? pin_code == null ? '' : pin_code : '',
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Country"
                        >
                            {getFieldDecorator('country', {
                                rules: [{ required: false, message: 'Line 1' }],
                                initialValue: editing ? country == null ? '' : country : '',
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        {/* –––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––– */}

                    </Form>

                </Modal>
            </div>
        );
    }
}

const AddressModalForm = Form.create()(UnwrappedAddressModalForm);

export default AddressModalForm;



// WEBPACK FOOTER //
// ./src/component/Users/AddressModalForm.js